export const HEADING_REGEX = /^h[1-6]$/
